export function normalizeIban(value: string): string {
  return value.replace(/\s+/g, '').toUpperCase();
}

export function isValidBelgianIban(value: string): boolean {
  const iban = normalizeIban(value);

  if (!/^BE\d{14}$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const numeric = rearranged
    .split('')
    .map((c) => (Number.isNaN(Number(c)) ? c.charCodeAt(0) - 55 : c))
    .join('');

  let remainder = numeric;
  while (remainder.length > 2) {
    remainder = (parseInt(remainder.slice(0, 9), 10) % 97) + remainder.slice(9);
  }

  return parseInt(remainder, 10) % 97 === 1;
}

export function formatIbanDisplay(value: string): string {
  const iban = normalizeIban(value);
  return iban.replace(/(.{4})/g, '$1 ').trim();
}